export function stripeMetadata(chosenProduct, chosenSlot, accessories, about, totalPrice, bookingId, invite, operatorId, coupon) {
    const accessoryIds = accessories.length === 0 ? null : accessories.map(accessory => accessory.id).join(",");
    let result = {
        bookingId,
        operatorId,
        ...about,
        totalPrice,
        chosenDate: chosenProduct.id,
        chosenProductId: chosenProduct.productId,
        chosenSlotId: chosenSlot.id,
        chosenSlotLabel: chosenSlot.label,
    };
    if (accessoryIds !== null) {
        result = { ...result, accessoryIds };
    }
    if (invite) {
        result = { ...result, invitationUniqueCode: invite.uniqueCode };
    }
    if (coupon) {
        result = { ...result, couponCode: coupon.couponCode };
    }
    return result;
}
